let generator = null;

const get = async () => {
  if (!generator) {
    throw new Error('CSS generator is not initialized.');
  }

  return generator;
};

const set = (newGenerator) => {
  if (!newGenerator) {
    throw new Error('New generator must be provided.');
  }

  generator = newGenerator;
};

export { get, set };
